export function showError(element, message) {
    const container = element.closest(".track-container, .card, .modal-body") || element.parentElement;
    let status = container.querySelector(".trend-action-error");
    if (!status) {
        status = document.createElement("p");
        status.className = "trend-action-error font-size-12 mt-2";
        status.setAttribute("role", "alert");
        container.appendChild(status);
    }
    status.textContent = message;
}

export async function requestJson(url, options = {}) {
    const response = await fetch(url, {
        credentials: "same-origin",
        ...options,
        headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
            ...options.headers,
        },
    });
    if (!response.ok || response.redirected) {
        throw new Error("Request was not accepted");
    }
    const result = response.status === 204 ? true : await response.json();
    if (!result || result.success === false || result.error || (result.errors && Object.keys(result.errors).length)) {
        throw new Error("Request was not accepted");
    }
    return result;
}

export function formPost(url, fields) {
    return requestJson(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fields).toString(),
    });
}
